import axiosInstance from './axios';

async function get<T>(path: string): Promise<T> {
  const response = await axiosInstance.get<T>(path);
  return response.data;
}

async function post<T>(path: string, payload: unknown): Promise<T> {
  const response = await axiosInstance.post<T>(path, payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

async function postFile<T>(path: string, formData: FormData): Promise<T> {
  const response = await axiosInstance.post<T>(path, formData);
  return response.data;
}

async function put<T>(path: string, payload: unknown): Promise<T> {
  const response = await axiosInstance.put<T>(path, payload);
  return response.data;
}

async function del<T>(path: string): Promise<T> {
  const response = await axiosInstance.delete<T>(path);
  return response.data;
}

export const fetchModelBlob = async (url: string): Promise<Blob> => {
  const response = await Api.axios.get(url, {
    responseType: 'blob',
  });
  return response.data;
};

const Api = {
  get,
  post,
  postFile,
  put,
  delete: del,
  axios: axiosInstance, // optional: export raw instance for full control
};

export default Api;
